import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation ($id: String!, $reaction: String!) {
    toggleGroupPostReaction(groupPostId: $id, reaction: $reaction) {
      success
      message
    }
  }
`

export interface ToggleGroupPostReactionInput {
  id: string // Post id
  reaction: string
}

export interface ToggleGroupPostReactionOutput {
  toggleGroupPostReaction: {
    success: boolean
    message: string
  }
}

export const useTogglePostReaction = () =>
  useMutation<ToggleGroupPostReactionOutput, ToggleGroupPostReactionInput>(mutation)
